"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("../");

var _LogisticTaskFooterComponent = _interopRequireDefault(require("./LogisticTaskFooter-component"));

var _LogisticTimeLineComponent = _interopRequireDefault(require("./LogisticTimeLine-component"));

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Stack = _interopRequireDefault(require("../Stack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskTypeEnum;

(function (TaskTypeEnum) {
  TaskTypeEnum["collection"] = "collection";
  TaskTypeEnum["delivery"] = "delivery";
})(TaskTypeEnum || (TaskTypeEnum = {}));

var TaskStatusEnum;

(function (TaskStatusEnum) {
  TaskStatusEnum["unassigned"] = "unassigned";
  TaskStatusEnum["assigned"] = "assigned";
  TaskStatusEnum["loaded"] = "loaded";
  TaskStatusEnum["not-present"] = "not-present";
  TaskStatusEnum["done"] = "done";
  TaskStatusEnum["canceled"] = "canceled";
})(TaskStatusEnum || (TaskStatusEnum = {}));

const set_collection_placeholder_task = {
  address_latitude: 0,
  address_longitude: 0,
  address_text: "محل مورد نظر خود را برای جمع آوری انتخاب کنید.",
  driver: undefined,
  id: 0,
  period: {
    id: 0,
    date: "",
    start: "",
    end: "",
    title: "زمان جمع آوری را انتخاب کنید."
  },
  status: "",
  task_type: TaskTypeEnum.collection
};
const delivery_placeholder_task = {
  id: 0,
  address_text: "پس از آماده‌‌شدن پیامک دریافت می‌کنید",
  period: {
    id: 0,
    date: "",
    title: "",
    start: "",
    end: ""
  },
  task_type: TaskTypeEnum.delivery,
  status: "done",
  address_longitude: 0,
  address_latitude: 0,
  driver: undefined
};
const set_delivery_placeholder_task = {
  address_latitude: 0,
  address_longitude: 0,
  address_text: "محل مورد نظر خود را برای تحویل انتخاب کنید.",
  driver: undefined,
  id: 0,
  period: {
    id: 0,
    date: "",
    start: "",
    end: "",
    title: "زمان تحویل را انتخاب کنید."
  },
  status: "",
  task_type: TaskTypeEnum.delivery
};

function actions_as_task(status) {
  let output = [];

  if (!status) {
    return [set_collection_placeholder_task];
  } else {
    if (["submitted_by_crm", "submitted_by_customer", "collection_canceled", "collection_not_present"].includes(status)) {
      output.push(set_collection_placeholder_task);
    }

    if (["delivery_canceled", "delivery_not_present", "work_done"].includes(status)) {
      output.push(set_delivery_placeholder_task);
    }

    if (["collected", "ready_to_collect", "submitted_by_customer", "submitted_by_crm", "collection_canceled", "collection_not_present", "unwrapped", "in_progress"].includes(status)) {
      output.push(delivery_placeholder_task);
    }

    return output;
  }
}

function LogisticsHistory(props) {
  let disabled = ["canceled_by_customer", "canceled_by_system"].includes(props.status || "");
  let actions = disabled ? [] : actions_as_task(props.status);

  if (disabled && props.list.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_Stack.default, {
      distribution: "center"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "\u0633\u0631\u0648\u06CC\u0633 \u062D\u0645\u0644 \u0648 \u0646\u0642\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A."));
  }

  return /*#__PURE__*/_react.default.createElement(_.Box, null, /*#__PURE__*/_react.default.createElement(_LogisticTimeLineComponent.default, {
    theme: props.theme,
    icon: props.icons.normal,
    activeIcon: props.icons.active
  }, props.list?.map(item => {
    let active = item.status === "unassigned" || item.status === "assigned";
    return /*#__PURE__*/_react.default.createElement(_.LogisticTask, {
      key: item.id,
      active: active,
      data: item,
      taskLink: props.permission && props.taskLink && props.permission("add_task") ? `${props.taskLink(item.id)}` : undefined,
      footer: /*#__PURE__*/_react.default.createElement(_LogisticTaskFooterComponent.default, {
        onCanceled: () => {
          if (props.onCanceled) {
            props.onCanceled(item);
          }
        },
        onReschedule: () => {
          if (props.onReschedule) {
            props.onReschedule(item);
          }
        },
        data: item,
        policy: props.policy,
        logisticTimeIcon: props.icons.time,
        inPerson: item.in_person
      }),
      theme: props.theme
    });
  }), actions.map((action_task, index) => {
    let actionable = action_task.status !== "done";
    return /*#__PURE__*/_react.default.createElement(_.LogisticTask, {
      key: index,
      data: action_task,
      theme: props.theme,
      active: actionable,
      line: actionable,
      footer: /*#__PURE__*/_react.default.createElement(_LogisticTaskFooterComponent.default, {
        onAdd: actionable ? props.onAdd : undefined,
        data: action_task,
        policy: props.policy
      })
    });
  })));
}

var _default = LogisticsHistory;
exports.default = _default;